var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.498,
    height: 44.336,
    viewBox: "0 0 61.498 44.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Attachment",
    d: "M139.945,106.4a17.867,17.867,0,0,0-17.766,15.8,14.3,14.3,0,0,0,1.318,28.537h35.039a12.156,12.156,0,0,0,0-24.313h-.849A17.882,17.882,0,0,0,139.944,106.4Zm0,15.017a1.247,1.247,0,0,1,.961.358l7.866,7.151a1.453,1.453,0,0,1,.112,2.034,1.524,1.524,0,0,1-2.034.089l-5.475-4.984v15.374a1.43,1.43,0,1,1-2.86,0V126.064l-5.475,4.983a1.5,1.5,0,0,1-2.034-.089,1.47,1.47,0,0,1,.112-2.034l7.866-7.151a1.556,1.556,0,0,1,.961-.358Z",
    transform: "translate(-109.195 -106.4)",
    fill: "#999",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse);
export default __webpack_public_path__ + "static/media/browse.2615e73a2f9cb8c78e02c08de7bf6a20.svg";
export { ForwardRef as ReactComponent };